import type { Surface } from "@/lib/surface-detect";

// Surface-gate allow rule (Story 7.1 spike → Story 6.9 enforcement → gh-469 hard block).
// The iOS install gate is ENFORCING: on a non-PWA iOS surface a clinician cannot create
// offline-capable work, because each surface has its own evictable IndexedDB bucket and
// only the installed PWA (`pwa-proper`) has durable, isolated storage. The only forward
// path is installing/opening the PWA (which re-classifies the surface). There is no
// "Continue anyway" escape hatch and no session override (removed in gh-469 — it was the
// hole that made the gate advisory). This one allow-rule is the single source of truth
// shared by the SurfaceGuard and `useStartEvaluation`, so the gated call-sites cannot
// diverge.

/**
 * Whether the current surface may create offline-capable work WITHOUT the install gate.
 * `other` (desktop/Android/non-iOS) is never gated, and `pwa-proper` is the one iOS
 * surface with durable isolated storage. Every other iOS surface is gated.
 */
export function isSurfaceAllowed(surface: Surface): boolean {
  return surface === "other" || surface === "pwa-proper";
}
